import { phoneSchema } from "@repo/components/src/utils/yup";
import * as yup from "yup";

export const PHONE_REQUIRED = "Ingresa tu número de WhatsApp para continuar.";
const PHONE_INVALID = "Revisa tu número: no parece válido.";
const TERMS_REQUIRED = "Debes aceptar los términos para continuar.";

/**
 * The phone, validated as one value: its error lands on `phone` itself, which is the
 * field's one `Controller`. An error on `phone.number` is dropped by
 * `trigger("phone")` and never re-renders that Controller.
 */
export const registerPhoneSchema = phoneSchema
  .shape({ number: yup.string().defined() })
  .test("phone", PHONE_INVALID, (value, context) => {
    const digits = value?.number ?? "";
    if (!digits) return context.createError({ message: PHONE_REQUIRED });
    return digits.length >= 7 && digits.length <= 15;
  });

export const acceptedTermsSchema = yup
  .boolean()
  .oneOf([true], TERMS_REQUIRED)
  .required(TERMS_REQUIRED);
